<template>
  <div>
    <i class="fas fa-eye-slash" /> Results are hidden
    <button
      class="btn btn-outline-dark btn-sm"
      @click="showResult"
    >
      Show results
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    showResult() {
      this.updateSlideActiveAction({
        hideResult: false,
      })
      this.$emit('updateSlide', {
        accessCode: this.presentation.uniqueAccessCode,
        hideResult: false,
      }, 1)
    },
  },
}
</script>
